import React from 'react';
import { Helmet } from 'react-helmet-async';
import GhaziabadLocation from '../components/GhaziabadLocation';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://wayug.com/' },
    { '@type': 'ListItem', position: 2, name: 'Ghaziabad', item: 'https://wayug.com/ghaziabad' },
  ],
};

export default function GhaziabadPage() {
  return (
    <div className="page-content subpage-content">
      <Helmet>
        <title>Software Development Company in Ghaziabad | Custom Software &amp; ERP – Wayug</title>
        <meta
          name="description"
          content="Leading software development company serving Ghaziabad, Sahibabad &amp; Delhi NCR. Custom ERP for steel &amp; manufacturing, Mediway hospital software, CRM &amp; mobile apps."
        />
        <link rel="canonical" href="https://wayug.com/ghaziabad" />
        <meta property="og:title" content="Software Development Company in Ghaziabad | Wayug Infotech" />
        <meta
          property="og:description"
          content="Empowering Ghaziabad businesses with custom software, manufacturing ERP, hospital information systems, and IT consulting. Just 19km from Ghaziabad."
        />
        <meta property="og:url" content="https://wayug.com/ghaziabad" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      </Helmet>
      <GhaziabadLocation />
    </div>
  );
}
